import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTimeAdd = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.5 0C3.375 0 0 3.375 0 7.5H1.875C1.875 4.40625 4.40625 1.875 7.5 1.875C10.5938 1.875 13.125 4.40625 13.125 7.5C13.125 10.5938 10.5938 13.125 7.5 13.125V15C11.625 15 15 11.625 15 7.5C15 3.375 11.625 0 7.5 0ZM6.5625 8.4375V3.75H8.4375V6.5625H12V8.4375H6.5625Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.5 8H2.5V10.5H0V12.5H2.5V15H4.5V12.5H7V10.5H4.5V8Z",
		fill: "currentColor"
	})]
});
export default SvgIconTimeAdd;
